import { BarsOutlined } from "@ant-design/icons";
import { Layout, Menu, message } from "antd";
import { get } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { matchPath } from "react-router";
import { Link } from "react-router-dom";

import { breadcurmbs } from "components/Breadcrumb";
import Header from "components/Header";
import ChangePasswordModal from "components/UpdatePasswordModal";

import { flatRouteMap, menuByRouteName, routes } from "router";

import Loading from "components/Loading";
import { MENU_CONFIG } from "config";
import { STORAGE_KEYS, UPDATE_PASSWORD_LIMIT_DAYS } from "shared/constant";
import "./app.scss";

message.config({ top: 74 });

export default function App(props) {
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);

  const { getUser, location, children, updatePassword, user } = props;

  useEffect(() => {
    async function init() {
      setLoading(true);
      const { data: user } = await getUser();
      if (user) {
        const needUpdatePassword =
          !user.updatePasswordAt ||
          user.updatePasswordAt < moment().subtract(UPDATE_PASSWORD_LIMIT_DAYS, "day").endOf("day").valueOf() / 1000;
        if (needUpdatePassword) setShowChangePasswordModal(true);
        // 登入一次 顯示一次modal
        localStorage.setItem(STORAGE_KEYS.OPEN_MODAL, "true");
      }
      setLoading(false);
    }
    const isOpenModal = localStorage.getItem(STORAGE_KEYS.OPEN_MODAL);
    if (isOpenModal) return;
    init();
  }, []);
  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
  };

  const handleUpdatePassword = async (updateData) => {
    const { success, code } = await updatePassword(user.id, updateData);
    if (success) {
      message.success("更新成功");
      setShowChangePasswordModal(false);
    } else {
      if (code === 10003) message.error("密碼與前三次相同，請重新輸入");
      else message.error("更新發生錯誤");
    }
  };

  const { pageKey, routeObj } = useMemo(() => {
    const keys = Object.keys(routes);
    let pageKey = "",
      routeObj = { params: {} };
    for (let key of keys) {
      if (!routes[key].path) continue;
      const matched = matchPath(location.pathname, {
        path: routes[key].path
      });
      if (matched) {
        pageKey = key;
        routeObj = matched;
        break;
      }
    }
    return { pageKey, routeObj };
  }, [location]);

  if (loading) return <Loading />;
  const selectedKey = get(flatRouteMap, `[${pageKey}][0].path`);

  return (
    <Layout>
      <Layout.Sider theme="light" width={240} collapsible breakpoint="lg" collapsed={collapsed} onCollapse={onCollapse}>
        <span
          className="ant-layout-sider-zero-width-trigger ant-layout-sider-zero-width-trigger-left"
          onClick={() => onCollapse(!collapsed)}
        >
          <BarsOutlined></BarsOutlined>
        </span>

        <Menu theme="light" mode="inline" selectedKeys={[selectedKey]}>
          <Menu.Item key="banner">
            <Link to="/net-zero/home">
              <div className="logo"></div>
            </Link>
          </Menu.Item>
          {MENU_CONFIG.map((r) => menuByRouteName(r))}
        </Menu>
      </Layout.Sider>

      <Header location={location} {...props} />

      <Layout className="fixed-header fixed-sider">
        {routes[pageKey]?.showBreadcrumb && breadcurmbs(pageKey, routeObj.params.id === "create")}
        <Layout.Content>{children}</Layout.Content>
      </Layout>
      <ChangePasswordModal open={showChangePasswordModal} onOk={handleUpdatePassword} />
    </Layout>
  );
}
